import type { ReactNode } from 'react';
import React from 'react';

import {
  ModalLabel,
  ModalRow,
} from '@fragment/ui/src/components/Modal/ModalField';

/** `ModalField` row without the `ModalValue` fill, so tabbed buttons sit on the canvas. */
export const ToggleField = ({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) => (
  <ModalRow>
    <ModalLabel width="w-[30%] max-w-[16ch]" borderWidth="border-r-[0px]">
      {label}
    </ModalLabel>
    {children}
  </ModalRow>
);
